<mat-nav-list>
    <div class="profile-card">
        <div class="header">
            <h2>Malini Sengupta</h2>
            <h4>malini@link2future.ca</h4>
        </div>
        <img mat-card-image src="../../../../assets/images/profile-pictures/team-member-2.jpg" alt="Photo of a Jaciel">
    </div>
    <mat-divider></mat-divider>

    <h2 matSubheader>Pages</h2>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/home">
        <mat-icon>dashboard</mat-icon>
        Home
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/clients">
        <mat-icon>assignment_turned_in</mat-icon>
        Clients
    </a>
    <a mat-list-item routerLinkActive="list-item-active" (click)="open(paypalModal)">
        <mat-icon>payment</mat-icon>
        Paypal
    </a>
    <a mat-list-item routerLinkActive="list-item-active" (click)="open(applyBoardModal)">
        <mat-icon>assignment_late</mat-icon>
        ApplyBoard
    </a>
    <mat-divider></mat-divider>

    <!-- <h2 matSubheader>Tools</h2>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/">
        <mat-icon>import_contacts</mat-icon>
        Tool 1
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/">
        <mat-icon>contact_phone</mat-icon>
        Tool 2
    </a> -->

</mat-nav-list>


<ng-template #paypalModal let-modal>
    <div class="modal-header">
        <!-- <h1 class="modal-title" id="modal-basic-title">Paypal Portal</h1> -->
        <button type="button" class="close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <h3 style="text-align: center;">You are currently exiting from the Link2Future web portal.</h3>
        <h3 style="text-align: center;">Click the GO button in order to get redirected</h3>
        <img src="../../../../assets/images/logo/paypal_logo.png" style="margin-left: 100px;" width="250" height="200">
    </div>
    <!-- <div class="modal-footer">
        <a href="https://www.paypal.com/us/signin" class="btn btn-primary">Go</a>
    </div> -->
    <div class="footer-custom">
        <a class="button-custom" href="https://www.paypal.com/us/signin" mat-raised-button color="primary">Go</a>
    </div>
</ng-template>

<ng-template #applyBoardModal let-modal>
    <div class="modal-header">
        <!-- <h1 class="modal-title" id="modal-basic-title">ApplyBoard Portal</h1> -->
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body apply-board-div">
        <h3 style="text-align: center;">You are currently exiting from the Link2Future web portal.</h3>
        <h3 style="text-align: center;">Click the GO button in order to get redirected.</h3>
        <img src="../../../../assets/images/logo/ab_logo.png" style="margin-left: 100px;">
    </div>
    <div class="footer-custom">
        <a class="button-custom" href="https://www.applyboard.com/partners/Link2Future#referral_page_signup"
            mat-raised-button color="primary">Go</a>
    </div>
</ng-template>